import styled from 'styled-components';
import { THEME_COLORS } from '../../styles/theme';
import { FontSize18, FontFamilyMedium, FontFamilyRegular, FontSize10 } from '../fonts';
import { TextAlignCenter, TextBlock } from '../text';
import { MarginBottom20 } from '../margins';
import { ButtonGradient } from '../Buttons';

export const BottomSheetContainer = styled.div`
    display: block;
    height: 120px;
    background-color: white;
    ${props => props.theme.mediaQueries[props.maxExcludedScreenSize]} {
        display: none;
    }
`;

export const TriggerContainer = styled.div`
    position: fixed;
    z-index: 900;
    height: 100%;
    bottom: 0;
    left: 0;
    right: 0;
    height: 64px;
    background-color: white;
    box-shadow: 0 2px 30px 0 rgba(0, 0, 0, 0.2);
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const ContentContainer = styled.div`
    padding: 0 20px;
    position: fixed;
    z-index: 2;
    bottom: 0;
    right: 0;
    left: 0;
    height: 100%;
    z-index: 1000;
    transition: transform 0.5s ease-in-out;
    transform: ${props => props.isActive ? 'translateY(0)' : 'translateY(100%)'};
    background: ${props => props.backgroundColor ? 
        props.theme.color[THEME_COLORS[props.backgroundColor]]
        : props.theme.color[THEME_COLORS.white]
    };
`;

export const HeaderContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    padding: 0 8px 8px 8px;
    &:hover {
        cursor: pointer;
    }
`;

export const CloseIconWrapper = styled.div`
    width: 20px;
    height: 20px;
`;

export const BottomsheetTriggerContainer = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
`;

export const BottomsheetTriggerTitle = styled.p`
    ${FontSize18};
    ${FontFamilyMedium};
    font-weight: 500;
    margin: 0;
`;

export const BottomsheetTriggerSubTitle = styled.p`
    ${FontSize10};
    ${FontFamilyRegular};
`;

export const BottomSheetCallMeButton = styled(ButtonGradient)`
    width: 42px;
    height: 42px;
    padding: 0;
`;

export const BottomSheetHeaderText = styled(TextBlock)`
    ${FontSize10};
    width: 100%;
    ${TextAlignCenter};
    padding: 16px 0 16px 0;
`;